import { useEffect, useState } from 'react';
import useAlert from '../Alerts/useAlert';
import { client } from './AuthUtils';
import { useHttpUtils } from './useHttpUtils';

export const useUserAuthorization = () => {
    const account = client.getAllAccounts()[0];
    const { fetchDataAuthenticated } = useHttpUtils();
    const { setAlert } = useAlert();
    const [checkingAuthorization, setCheckingAuthorization] = useState<boolean>(true);
    const [userIsAuthorized, setUserIsAuthorized] = useState<boolean>();

    useEffect(() => {
        if (account?.username) {
            fetchDataAuthenticated("api/v1/user/checkAuthorization?username=" + account.username)
                .then(async (response) => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error(await response.json());
                })
                .then(data => {
                    setUserIsAuthorized(data);
                })
                .catch(error => {
                    setAlert("danger", "Error", "Failed to check auer authorization. " + error.message);
                })
                .finally(() => {
                    setCheckingAuthorization(false);
                });
        }
    }, [account.username, fetchDataAuthenticated, setAlert]);

    return { checkingAuthorization, userIsAuthorized };
};
